import classnames from 'classnames';
import PropertyStatusBar from 'components/common/PropertyStatusBar';
import React from 'react';
import styles from './styles.scss';

interface Props {
  tg1Count: number;
  tg2Count: number;
  tg3Count: number;
  title?: string;
  className?: string;
}
const PropertyStatusWrapper = ({ tg1Count, tg2Count, tg3Count, title, className }: Props): JSX.Element => {
  const numRemarks = tg2Count + tg3Count;
  const numTotal = tg1Count + tg2Count + tg3Count;
  const subHeader = `${numRemarks} avvik av ${numTotal} kontrollerte bygningsdeler`;
  return (
    <section className={classnames(styles.container, className)}>
      {title && <h2 className={styles.title}>{title}</h2>}
      {numTotal > 0 ? (
        <>
          <h3 className={styles.subHeader}>{subHeader}</h3>
          <PropertyStatusBar tg1Count={tg1Count} tg2Count={tg2Count} tg3Count={tg3Count} />
        </>
      ) : (
        <h3 className={styles.subHeader}>Ingen sjekkpunkter funnet.</h3>
      )}
    </section>
  );
};

PropertyStatusWrapper.defaultProps = {
  title: 'Hva er boligens tilstand?',
  tg1Count: 0,
  tg2Count: 0,
  tg3Count: 0,
};

export default PropertyStatusWrapper;
